import NavBarCRM from "./ui/NavBar/NavBarCRM.vue";
import MessageNav from "./ui/MessageNav/MessageNav.vue";
import MessageDialog from "./ui/MessageDialog/MessageDialog.vue";
import MessageCenter from "./ui/MessageCenter/MessageCenter.vue";
import BreadCrumb from "./ui/BreadCrumb/BreadCrumb.vue";
import DescText from "./ui/DescText/DescText.vue";
import FontTip from "./ui/FontTip/FontTip.vue";
import DateShortCut from "./ui/DateShortCut/DateShortCut.vue";

export const registerComponent = (Vue) => {
  Vue.component('navbar-e', NavBarCRM);
  Vue.component('comp-navbar-e', NavBarCRM);
  Vue.component('comp-message-nav', MessageNav);
  Vue.component('comp-message-dialog', MessageDialog);
  Vue.component('comp-message-center', MessageCenter);
  Vue.component('comp-bread-crumb', BreadCrumb);
  Vue.component('comp-desc-text', DescText);
  Vue.component('comp-font-tip', FontTip);
  Vue.component('comp-date-short-cut', DateShortCut);
};



// WEBPACK FOOTER //
// ./src/index.js